<template>
  <div class="keyboard-container-wrap" style="pointer-events: none;">
    <!-- info btn -->
    <div class="info-btn-wrap" style="pointer-events: all;">
      <button type="button" class="navigation-info-btn"></button>
      <!-- info popup -->
      <div class="keyboard-container" v-show="show">      
        <div class="flex-row">
          <div class="arrow-vertical">
            <img alt="Edit Button" src="@/assets/img/icons/small-arrow-up.svg">
            <img alt="Edit Button" src="@/assets/img/icons/small-arrow-down.svg">
          </div>
          <span class="navigation-text navigation-text-type-1">You can navigate between creatives using the up and down cursor buttons on your keyboard.</span>
        </div>
        <div class="flex-row">
          <div class="arrow-horizontal flex-row">
            <img alt="Edit Button" src="@/assets/img/icons/small-arrow-left.svg">
            <img alt="Edit Button" src="@/assets/img/icons/small-arrow-right.svg">
          </div>
          <span class="navigation-text navigation-text-type-2">You can navigate between versions of the creative usig the left and right cursor buttons on your
            keyboard.</span>
          <div>
          </div>
        </div>
      </div>
    </div>
    <!-- zoom btns -->
    <div class="zoomer-container"  style="pointer-events: all;">
      <button type="button" @click="$parent.scale*=0.9" title="zoom out">
        <img class="zoom-icon--minus" alt="Minus Button" src="@/assets/img/icons/minus.svg">
      </button>
     
        <input class="zoominput"  v-model="myscale" @change="scaleChanged" />
     
      <button type="button" class="pointer" @click="$parent.scale*=1.1" title="zoom in">
        <img class="zoom-icon--plus"  alt="Plus Button" src="@/assets/img/icons/plus.svg">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CursorNavigation",
  data(){
    return {
      myscale: 100,
      show: (window.localStorage.getItem('approvelyInfoBox') == null) ? true : false,
    }
  },
  watch:{
    '$parent.scale':function(){
      
      this.myscale = parseInt(this.$parent.scale *100);
     // console.log('watch:' , this.$parent.scale,this.myscale)
      this.$forceUpdate();
        
      }
    
  },
  mounted(){
    var _this = this;
    setTimeout(function(){
      window.localStorage.setItem('approvelyInfoBox',1);
      _this.show = false;
    },8000)
  },
  methods:{
    scaleChanged() {
      //console.log('myscale changed',this.myscale);
      this.$parent.scale = this.myscale/100;
    }
  }

  
}
</script>

<style scoped>

</style>